//
//
//
//
//

const radioName = Date.now()
export default {
	name: 'RadioGroup',
	props: {
		value: {
			type: [String, Number],
			default() {
				return undefined
			}
		},
		horizontal: {
			type: Boolean,
			default() {
				return false
			}
		},
		right: {
			type: Boolean,
			default() {
				return false
			}
		}
	},
	data() {
		return {
			currentValue: undefined
		}
	},
	created() {
		this.currentValue = this.value
	},
	computed: {
		radioList() {
			return this.$children || []
		},
		dynamicClass() {
			return {
				'flex-row': this.horizontal,
				'flex-column': !this.horizontal,
				'my-radio-group-small': this.size === 'small',
				'my-radio-group-right': this.right,
				'my-radio-group-row-right': this.horizontal && this.right
			}
		}
	},
	methods: {
		change(value) {
      if (this.currentValue === value) {
        this.currentValue = ''
        this.$emit('input', '')
			  this.$emit('onChange', '')
        return
      }
			this.currentValue = value
			this.$emit('input', value)
			this.$emit('onChange', value)
		},
		getRadioName() {
			return radioName
		}
	},
	watch: {
		value(value) {
			this.currentValue = value
		}
	}
}
